import { useEffect, useState } from 'react'

export const DESK_BREAKPOINT = 1014

export function useIsBelowDesk(breakpoint: number = DESK_BREAKPOINT): boolean {
  const [isBelowDesk, setIsBelowDesk] = useState(window.innerWidth < breakpoint)

  useEffect(() => {
    const handleResize = () => setIsBelowDesk(window.innerWidth < breakpoint)

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [breakpoint])

  return isBelowDesk
}
